import "../css/app.scss";
// import "bootstrap";
import * as bootstrap from "bootstrap";
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.bootstrap4.css";

document.addEventListener("DOMContentLoaded", function() {
  let settings = {
    plugins: {
      clear_button: {
        title: "Remove all selected options"
      },
      remove_button: {
        title: "Remove this item"
      }
    }

  };
  document.querySelectorAll(".tom-select").forEach(function(el) {
    if (!el.tomselect) {
      new TomSelect(el, settings);
    }
  });
});


(function() {
  // FIXME: There are more than one instances of modal backdrop at some point,
  // and we were not yet able to understand why. This is temporary hack to circumvent that.
  const modalNative = document.querySelector("#executive-modal");
  if (!modalNative) return;
   
  modalNative.addEventListener("shown.bs.modal", function() {
    const backdrops = document.querySelectorAll(".modal-backdrop.show");
    if (backdrops.length <= 1) return;
    for (let i = 1; i < backdrops.length - 1; i++) {
      backdrops[i].remove();
    }
  });

  const modal = new bootstrap.Modal("#executive-modal");
  htmx.on("htmx:beforeSwap", e => {

    if (e.detail.target.id === "executive-dialog" && !e.detail.xhr.response) {
      if (!modal._element) return;
      modal.hide();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  });
})();
